import { BADGES } from '@/data/constants';
import { cn } from '@/lib/utils';
interface BadgeDisplayProps {
  badges: string[];
  showAll?: boolean;
  className?: string;
}
export function BadgeDisplay({
  badges,
  showAll = false,
  className
}: BadgeDisplayProps) {
  const displayBadges = showAll ? badges : badges.slice(0, 4);
  const remaining = badges.length - displayBadges.length;
  return <div className={cn('flex items-center gap-1', className)}>
      {displayBadges.map(badgeId => {
      const badge = BADGES[badgeId as keyof typeof BADGES];
      if (!badge) return null;
      return;
    })}
      {remaining > 0 && <div className="w-8 h-8 rounded-full bg-muted flex items-center justify-center text-xs font-medium text-muted-foreground">
          +{remaining}
        </div>}
    </div>;
}